import React, { useEffect, memo, useCallback, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { logging } from '../../actions/log';
import { cacheKeys } from '../../constants/storageKeys';
import { logNative, getQueryString } from '../../utils/utils';
import styles from './OtherPage.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

export default function OtherPage() {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);

  const iframeRef = useRef(null);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false); // 是否已经加载完毕

  const pageUrl = decodeURIComponent(getQueryString('pageUrl') || '');
  const bizInfo = getQueryString('bizInfo');

  // pv打桩
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Iframe_Other_Page`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            pageUrl,
          },
          bizInfo: bizInfo,
        }),
      );
    };
  }, []);

  /**
   * 注册接受消息
   */
  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      window.addEventListener('message', receptIframeMessage, true);
    }
  }, [iframeRef]);

  /**
   * 推送登录信息, 退出登录，登录了都post登录了的用户信息
   */
  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow && isIframeLoaded) {
      postLoginInfo();
    }
  }, [iframeRef, userInfo, isIframeLoaded]);

  // 推送登录信息
  const postLoginInfo = useCallback(() => {
    if (iframeRef && iframeRef.current && iframeRef.current.contentWindow) {
      const userToken = localStorage.getItem(cacheKeys.X_LESYNC_TOKEN);
      const useInfoStr = localStorage.getItem(cacheKeys.USER_INFO) || '{}';
      const useInfoObj = { ...JSON.parse(useInfoStr), 'X-Lesync-Token': userToken };

      let machineInfo = JSON.parse(localStorage.getItem(cacheKeys.LOCALMACHINE_INFO) || '{}');
      const data = {
        acceptAddress: 'Game',
        sourceAddress: 'PCStore',
        type: 'loginInfo',
        data: {
          useInfo: useInfoObj,
          machineInfo,
        },
      };
      console.log('11111111111 向页面推送数据：useInfo, machineInfo', data);

      setTimeout(() => {
        iframeRef.current.contentWindow.postMessage(JSON.stringify(data), '*');
      }, 300);
    }
  }, [iframeRef]);

  /**
   * 接受的消息处理
   */
  const receptIframeMessage = useCallback(
    e => {
      try {
        const receptDate = JSON.parse(e && e.data);
        if (receptDate.acceptAddress === 'PCStore' && receptDate.sourceAddress === 'PCShop') {
          if (receptDate.type === 'getLoginInfo') {
            // 获取用户是否登录
            const login_status = window.CallNativeMethod('get_login_status');
            if (login_status === '1') {
              postLoginInfo();
            } else {
              // 弹出登录
              dispatch(
                logging({
                  category: 'C',
                  action: 'Show_Login',
                  label: '',
                  param2: {
                    source: 'Iframe_Other_Page',
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                    pageUrl,
                  },
                }),
              );
              window.CallNativeMethod('login');
            }
          }
        }
      } catch (error) {
        logNative('iframe接受的消息处理 错误', error);
      }
    },
    [iframeRef],
  );

  const iframeOnLoad = useCallback(e => {
    setIsIframeLoaded(true);
  }, []);

  return (
    <>
      <div className={styles.otherpage}>
        <iframe
          onLoad={iframeOnLoad}
          ref={iframeRef}
          src={`${pageUrl || 'https://hd.lenovomm.com/activity01/index.html?aid=289659473110656'}`}
          style={{ width: '840px', height: '590px', border: 'none' }}
        ></iframe>
      </div>
    </>
  );
}
